import {
    createSlice,
    createAsyncThunk,
    createEntityAdapter,
} from '@reduxjs/toolkit'
import * as API from '../utils/api'
import axios from '../utils/axios'

const initalState = {
    status: 'idle',
    entity: null,
    error: null,
}

export const fetchBuilding = createAsyncThunk(
    'buildings/fetchBuilding', 
    async (building_code) => {
        return await axios.get(`${API.BUILDINGS_API}/${building_code}`)
                            .then(response => response.data)
    }
)

const buildingSlice = createSlice({
    name: 'building',
    initialState: initalState,
    reducers: {
    
    },
    extraReducers: {
        [fetchBuilding.pending]: (state, action) => {
            state.status = 'loading'
        },
        [fetchBuilding.fulfilled]: (state, action) => {
            state.status = 'succeeded'
            state.entity = action.payload
        },
        [fetchBuilding.rejected]: (state, action) => {
            state.status = 'failed'
            state.error = action.error.message
        },
    }
})

export default buildingSlice.reducer